import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-reaction-tooltip',
  templateUrl: './reaction-tooltip.component.html',
  styleUrls: ['./reaction-tooltip.component.scss']
})
export class ReactionTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
